module.exports = __webpack_public_path__ + "static/media/B.b084a900.png";